import {Component, inject} from '@angular/core';
import {CommonTableConfig} from '@lib-ui/common-table/models/common-table-config.class';
import {LoaderComponent} from '@lib-ui/loader/loader.component';
import {ItemTableService} from './item-table.service';
import {CommonTableComponent} from '@lib-ui/common-table/ui/common-table.component';
import {ICommonTableAction, ICommonTableConfig} from '@lib-ui/common-table/models/common-table.interface';
import {RowAction} from '@lib-ui/common-table/models/common-table.enum';
import {MatDialog} from '@angular/material/dialog';
import {ItemFormComponent} from './item-form/item-form.component';
import {AdvancedSearchComponent} from '@lib-ui/advanced-search/ui/advanced-search.component';
import {FilterConfig} from '@lib-ui/advanced-search/models/advanced-search.interface';
import {FormControl} from '@angular/forms';
import {CategorySelectorService} from '@lib-services/category-selector.service';
import {filter, switchMap} from 'rxjs';
import {MessageService} from '@lib-services/message.service';
import {ItemService} from '@lib-services/items.service';

@Component({
    selector: 'app-item',
    standalone: true,
    imports: [
        CommonTableComponent,
        LoaderComponent,
        AdvancedSearchComponent,
    ],
    templateUrl: './item.component.html',
    styleUrl: './item.component.scss'
})
export class ItemComponent {
    tableConfig: ICommonTableConfig = new CommonTableConfig( {
        columns: [
            { name: 'id', title: 'ИН' },
            { name: 'name', title: 'Название' },
            { name: 'description', title: 'Описание', showToolTip: true },
            { name: 'categoryName', title: 'Категория' },
        ],
        createButtonLabel: 'Добавить оборудование',
        showCreateButton: true,
        withCheckboxes: true,
        rowActions: [RowAction.DELETE],
    });
    filterConfig: FilterConfig[];

    constructor(
        protected itemTableService: ItemTableService,
        private messageService: MessageService,
        private itemService: ItemService,
        public dialog: MatDialog,
    ) {
        this.filterConfig = [
            {
                type: 'input',
                label: 'Название',
                name: 'name',
            },
            {
                type: 'input',
                label: 'Описание',
                name: 'description',
            },
            {
                type: 'common-dropdown',
                label: 'Категория',
                name: 'category.id',
                commonDropdownConfig: {
                    service: inject(CategorySelectorService),
                    formCtrl: new FormControl(),
                },
            },
            // {
            //     type: 'common-dropdown',
            //     label: 'Компания',
            //     name: 'category.company.id',
            //     commonDropdownConfig: {
            //         service: inject(CompanySelectorService),
            //         formCtrl: new FormControl(),
            //     },
            // },
        ];
    }

    itemInfo(value: ICommonTableAction): void {
        if (value.action === RowAction.CLICK) {
            this.openDialog({ itemId: Number(value.data[0]['id']) });
        }
        if (value.action === RowAction.CREATE) {
            this.openDialog({});
        }
        if (value.action === RowAction.DELETE) {
            const ids = value.data.map(el => Number(el['id']));
            this.deleteItems(ids);
        }
    }

    openDialog(data: { itemId?: number }): void  {
        this.dialog.open(ItemFormComponent, {
            width: '60%',
            maxHeight: '500px',
            data: data,
            disableClose: true,
        }).afterClosed().subscribe({
            next: () => {
                this.itemTableService.updateData(this.tableConfig);
            }
        });
    };

    applyFilters(filterData: Record<string, string | null>): void {
        this.tableConfig.filters = filterData;
        this.tableConfig.paginatorConfig.pageIndex = 0;
        this.itemTableService.updateData(this.tableConfig);
    }

    deleteItems(ids: number[]): void {
        this.messageService.confirmMessage({
            title: 'Удаление оборудования',
            text: 'Вы действительно хотите удалить выбранные оборудования?',
            primaryText: 'Удалить',
            secondaryText: 'Отмена',
            showSecondaryButton: true,
        }).pipe(
            filter(result => result),
            switchMap(() => {
                return this.itemService.deleteItems(ids);
            }),
        ).subscribe({
            next: () => {
                this.messageService.successMessage('Оборудования успешно удалены');
                this.itemTableService.updateData(this.tableConfig);
            },
            error: () => this.messageService.errorMessage('При удалении произошла ошибка')
        });
    }

}
